import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { H4, Paragraph } from '../Typography'
import ValueIcon from './ValueIcon'

import { AlphaColors, Colors, Gutter } from '../../utils/styles'

// ValueListContainer
const ListTitle = styled(H4)({
  fontWeight: 500,
  fontSize: 24,
})

export const ValueListContainer = props => (
  <div>
    <ListTitle>{props.header}</ListTitle>
    {props.children}
  </div>
)

ValueListContainer.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.string,
}

ValueListContainer.defaultProps = {
  header: 'Value to Manufacturers',
}

// ValueListItem
const ListItem = styled.li({
  alignItems: 'flex-start',
  display: 'flex',
  listStyle: 'none',
  marginBottom: Gutter.HALF,
  fontSize: 16,
  lineHeight: '28px',
  fontWeight: 500,
  color: AlphaColors.BLACK_80,
})

const ListText = styled(Paragraph)({
  marginLeft: Gutter.HALF,
})

export const ValueListItem = props => (
  <ListItem>
    <div
      style={{
        marginTop: 2,
      }}
    >
      <ValueIcon iconColor={props.iconColor} />
    </div>
    <ListText>{props.text}</ListText>
  </ListItem>
)

ValueListItem.propTypes = {
  iconColor: PropTypes.string,
  text: PropTypes.string,
}

ValueListItem.defaultProps = {
  iconColor: Colors.BLACK,
  text: 'List Item Text',
}
